import { render, staticRenderFns } from "./Item.vue?vue&type=template&id=6ffde799&scoped=true"
import script from "./Item.vue?vue&type=script&lang=js"
export * from "./Item.vue?vue&type=script&lang=js"
import style0 from "./Item.vue?vue&type=style&index=0&id=6ffde799&prod&scoped=true&lang=css"
import style1 from "./Item.vue?vue&type=style&index=1&id=6ffde799&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ffde799",
  null
  
)

export default component.exports